export default __webpack_public_path__ + "d7131200a40472ee1614fde48ac7c1ab.svg";